import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { addMentor, selectCommon } from '../../../store/common';
import useDrawerScroll from '../../shared/hook/use-drawer-scroll';
import useGetMentors from '../../shared/hook/use-get-mentors';

const useMentorDrawer = () => {
  const location = useLocation();
  const { mentor } = useSelector(selectCommon);
  const { data: mentors } = useGetMentors();
  const dispatch = useDispatch();
  const history = useHistory();
  const { scrolled, onScroll } = useDrawerScroll({
    resetBy: mentor?.id,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mentorId = params.get('mentorId');

    if (!mentor && mentorId && mentors?.length) {
      const mentor = mentors.filter((item) => item.id === mentorId);

      if (mentor.length) {
        dispatch(addMentor({ mentor: mentor[0] }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, mentors]);

  const onClose = () => {
    dispatch(addMentor({}));

    const params = new URLSearchParams(location.search);
    const mentorId = params.get('mentorId');

    if (mentorId) {
      history.replace({
        pathname: window.location.pathname,
        search: '',
      });
    }
  };

  return { onClose, mentor, scrolled, onScroll };
};

export default useMentorDrawer;
